var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.286.5H1.71C1.043.5.5 1.05.5 1.726v14.548A1.22 1.22 0 0 0 1.71 17.5h14.576c.668 0 1.214-.55 1.214-1.226V1.726C17.5 1.05 16.954.5 16.286.5M5.638 15.071h-2.52V6.958h2.524v8.113zm-1.26-9.22a1.462 1.462 0 0 1 0-2.922c.805 0 1.461.656 1.461 1.46A1.46 1.46 0 0 1 4.38 5.85m10.705 9.22h-2.52v-3.946c0-.941-.019-2.152-1.309-2.152-1.313 0-1.514 1.025-1.514 2.084v4.014H7.22V6.958h2.417v1.109h.035c.337-.638 1.16-1.31 2.387-1.31 2.55 0 3.024 1.681 3.024 3.867z"
  })));
};
export default SvgLinkedin;